"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyorService = void 0;
var _surveyor = require("../controllers/surveyor.controller");
var SurveyorService = {
  survey: {
    update: _surveyor.config.survey + "/data-schema",
    info: _surveyor.config.survey + "/data-schema",
    field: _surveyor.config.survey + "/data-schema/list"
  }
};
exports.SurveyorService = SurveyorService;